import { render } from "./SubscriptionCoupon.vue?vue&type=template&id=596b616f"
import script from "./SubscriptionCoupon.vue?vue&type=script&lang=js"
export * from "./SubscriptionCoupon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__